module.exports = __webpack_public_path__ + "static/media/hot.af8b90c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/hot.png
// module id = 2036
// module chunks = 6